import EventBus from './event-bus';
import { EVENTS, base_url} from './constants';
import DataStore from './data-store';
import * as _ from 'lodash';
import UrlService from './url-service';
import { User } from '../../types';
import Cookies from 'js-cookie';
import Vue from 'vue';

let _factory = {
    isAuthenticated,
    isIdentityResolved,
    isInRole,
    isInAnyRole,
    logout,
    authenticate,
    identity,
    user: undefined,
    get AdminShopId() {
        let ShopId = Cookies.get('AdminShopId');
        return ShopId || _factory.user?.ShopId;
    },
    set AdminShopId(ShopId) {
        Cookies.set('AdminShopId',ShopId);
    },
};
let factory = Vue.observable(_factory);

export default factory;

init();
function init() {
	EventBus.$on(EVENTS.requestAdminLogin, () => {
        UrlService.go({ name: "admin-login", params: { next: UrlService.current() } });
    });
}

function authenticate(_identity: User) {
    factory.user = _identity;
    EventBus.$emit(EVENTS.login, factory.user);
}

function isIdentityResolved() {
    return !_.isUndefined(factory.user);
}
function isAuthenticated() {
    return factory.user != null;
}

function isInRole(role) {
    if (!factory.user || !factory.user.roles) return false;

    return factory.user.roles.indexOf(role) != -1;
}
function isInAnyRole(roles) {
    if (!factory.user || !factory.user.roles) return false;

    for (var i = 0; i < roles.length; i++) {
        if (isInRole(roles[i])) return true;
    }

    return false;
}

function logout() {
    return DataStore.post(base_url + '/admin/user/logout',{},'Erreur à la déconnexion')
    .then(data => {
        authenticate(null);
        UrlService.go(); // reload page
    });
}

let promise;
function identity(force = false) {
    if (force === true) {
        factory.user = undefined;
    }
    let deferred = {
        resolve: null,
        reject: null,
        promise: null,
    };
    let p = new Promise((resolve,reject) => {
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    deferred.promise = p;
    // check and see if we have retrieved the identity data from the server. if we have, reuse it by immediately resolving
    if (!_.isUndefined(factory.user)) {
        deferred.resolve(factory.user);

        return deferred.promise;
    }

    // check if there's already a request in flight to retrieve identity from the server
    if (promise) {
        return promise;
    }

    // otherwise, retrieve the identity data from the server, update the identity object, and then resolve.
    DataStore.get(base_url + '/admin/user/identity','Erreur de login')
    .then(data => {
        authenticate(data.identity)
        deferred.resolve(data.identity);
    })
    .catch(err => {
        authenticate(null)
        deferred.resolve(null);
    });

    promise = deferred.promise;
    return deferred.promise;
}